import dayjs from "dayjs";
import "dayjs/locale/ja";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("ja");
dayjs.tz.setDefault("Asia/Tokyo");

/** Japan Standard Time (JST) timezone identifier */
export const JST = "Asia/Tokyo";

/** Returns "today" in JST as a Date (for default values such as 発行日, 入金日, etc.) */
export function todayJST(): Date {
  const t = dayjs().tz(JST);
  return new Date(t.year(), t.month(), t.date());
}
